import React from 'react';
import style from './tabs.module.scss';
import cx from 'classnames';
import { TTab } from './tabs.model';

type Props = {
  tab: TTab;
  currentTab: TTab | null;
  onChange: (tab: TTab) => void;
  type?: 'solid' | 'outline';
  disabled?: boolean;
  children: any;
  tabIndex?: number;
};
export const TabItem = (props: Props) => {
  const { tab, currentTab, onChange, type = 'solid', children, disabled, tabIndex } = props;

  const classNames = cx(style.tabItem, { [style.active]: currentTab?.value === tab.value }, style[type], {
    [style.disabled]: disabled,
  });

  const handleClick = () => {
    if (currentTab?.value !== tab.value) {
      onChange(tab);
    }
  };

  return (
    <button tabIndex={tabIndex} className={classNames} onClick={handleClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default TabItem;
